<div class="row mt-5">
  <div class="col-12">
    <magieno-input-money-field [advancedFormControl]="this.campForm.formElements.careExpenses | asAdvancedFormControl"
                           [currency]="this.currency"
                           [locale]="this.locale"></magieno-input-money-field>

    <magieno-input-number-field
            [advancedFormControl]="this.campForm.formElements.numberOfWeeks | asAdvancedFormControl"></magieno-input-number-field>

  </div>
</div> <!-- / .row -->




